import Logo from './Logo.png'
import License from './PRINT_1.png'
import CarImg from './Rectangle86.png'

const assets = {
    Logo,
    License,
    CarImg,
}

export default assets;